import React from 'react';
import css from './NotFound.scss';

interface Props {
	actions?: React.ReactNode;
	title?: string;
}

const NotFound: React.FC<Props> = ({ title, actions }) => (
	<div className={css.notFound}>
		<div className={css.content}>
			<div className={css.imgWrap}>
				<svg viewBox="0 0 881 357">
					<defs>
						<linearGradient x1="100%" y1="50%" x2="14.3378764%" y2="50%" id="linearGradient-1">
							<stop stopColor="#00AB7B" stopOpacity="0.346513228" offset="0%" />
							<stop stopColor="#00AB7B" stopOpacity="0" offset="100%" />
						</linearGradient>
						<linearGradient x1="100%" y1="50%" x2="64.6706633%" y2="50%" id="linearGradient-2">
							<stop stopColor="#00AB7B" stopOpacity="0.339422906" offset="0%" />
							<stop stopColor="#00AB7B" stopOpacity="0" offset="100%" />
						</linearGradient>
					</defs>
					<g id="Website" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="404-copy" transform="translate(-176.000000, -173.000000)">
							<g id="Group" transform="translate(176.000000, 173.000000)">
								<text
									id="404"
									fill="#00A87E"
									fillRule="nonzero"
									fontFamily="Inter-SemiBold, Inter"
									fontSize="340"
									fontWeight="500"
									letterSpacing="-1.9125"
								>
									<tspan x="207" y="312">
										404
									</tspan>
								</text>
								<path
									// eslint-disable-next-line max-len
									d="M546.747475,98 C531.3367,98 349.087542,65.3333333 0,0 L0,357 L544.737374,279 C579.579125,279 597,248.666667 597,188 C597,100 557.165679,98 546.747475,98 Z"
									id="Path-2"
									fill="url(#linearGradient-1)"
								/>
								<path
									// eslint-disable-next-line max-len
									d="M546.747475,98 C539.925675,98 500.411607,91.5989106 428.205272,78.7967319 C367.597775,68.0510266 367.282081,140.392663 427.258188,295.821641 L544.737374,279 C579.579125,279 597,248.666667 597,188 C597,100 557.165679,98 546.747475,98 Z"
									id="Path-2"
									fill="url(#linearGradient-2)"
								/>
								<path
									// eslint-disable-next-line max-len
									d="M479.399865,89.2780703 C512.44539,94.9027384 532.949535,98.0867728 540.912298,98.8301737 C527.380381,100.040363 516.539884,107.609232 508.382955,121.534801 C499.448295,136.788116 494.94072,159.144886 494.860227,188.605114 C494.779735,208.325758 496.771922,224.907197 500.83679,238.349432 C504.901657,251.791667 510.676989,261.913589 518.162784,268.715199 C525.64858,275.516809 534.542992,278.917614 544.846023,278.917614 C546.136206,278.917614 547.40381,278.864461 548.648835,278.758156 C543.818248,280.06929 538.600503,280.816278 532.996678,281 L532.996678,281 L479.584574,288.816491 C472.043757,280.288868 465.846579,269.926032 460.99304,257.727983 C453.386506,238.611032 449.583239,215.570076 449.583239,188.605114 C449.663731,161.640152 453.507244,138.679687 461.113778,119.723722 C465.794722,108.058512 471.725442,98.0926924 478.905938,89.8262633 Z"
									id="Combined-Shape"
									fill="#1DCEA2"
									fillRule="nonzero"
								/>
								<path
									// eslint-disable-next-line max-len
									d="M349.88738,64.7295107 C362.244254,66.9712719 374.022537,69.099746 385.222229,71.1149328 L385.21,229.295 L416.84375,229.294034 L416.84375,266.119318 L385.21,266.12 L385.210102,301.841273 L342.468102,307.962273 L342.468,266.12 L224.507102,266.119318 L224.507102,230.50142 L329.428977,64.7272727 Z M342.951,115.4375 L341.019886,115.4375 L270.387784,227.362216 L270.387784,229.295 L342.951,229.295 L342.951,115.4375 Z"
									id="Combined-Shape"
									fill="#23C29B"
									fillRule="nonzero"
								/>
							</g>
						</g>
					</g>
				</svg>
			</div>
			{title ? <h1 className={css.title}>{title}</h1> : null}
		</div>
		{actions ? <div className={css.actions}>{actions}</div> : null}
	</div>
);

export default NotFound;
